import { Skeleton } from "@/components/ui/skeleton";

export const ServiceLoading = () => {
  return (
    <div className="min-h-screen">
      {/* Breadcrumb Loading */}
      <div className="bg-white/80 backdrop-blur-sm border-b border-gray-200">
        <div className="max-w-7xl mx-auto px-4 py-4">
          <Skeleton className="h-6 w-48" />
        </div>
      </div>
      
      {/* Hero Loading */}
      <div className="min-h-[60vh] bg-gradient-to-br from-primary/10 to-primary/5 flex items-center">
        <div className="max-w-7xl mx-auto px-4 py-20 grid md:grid-cols-2 gap-12 items-center w-full">
          <div className="space-y-6">
            <Skeleton className="h-16 w-full" />
            <Skeleton className="h-6 w-4/5" />
            <Skeleton className="h-6 w-3/4" />
            <div className="flex gap-4">
              <Skeleton className="h-12 w-32" />
              <Skeleton className="h-12 w-32" />
            </div>
          </div>
          <div className="space-y-4">
            <Skeleton className="h-64 w-full rounded-xl" />
          </div>
        </div>
      </div>
      
      {/* Content Sections Loading */}
      {[1, 2, 3].map((section) => (
        <div key={section} className="py-20">
          <div className="max-w-7xl mx-auto px-4">
            <div className="text-center mb-16 space-y-4">
              <Skeleton className="h-10 w-64 mx-auto" />
              <Skeleton className="h-6 w-96 mx-auto" />
            </div>
            
            <div className="grid md:grid-cols-3 gap-8">
              {[1, 2, 3].map((item) => (
                <div key={item} className="space-y-4">
                  <Skeleton className="h-48 w-full rounded-xl" />
                  <Skeleton className="h-6 w-full" />
                  <Skeleton className="h-4 w-4/5" />
                </div>
              ))}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};